// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1Hofq","button_dark":"Button_button_dark__1U3hi","button_light":"Button_button_light__2KFQW","button_selected":"Button_button_selected__31Czr"};